import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, Stack, Button } from "@mui/material";
import PropTypes from "prop-types";
import { buttonStyles } from "services/utils";
import AssignCompensationView from "./components/AssignCompensationView";
import BulkOnboardView from "./components/BulkOnboardView";
import CompensationHistoryView from "./components/CompensationHistoryView";

const EmployeesView = ({ canEdit }) => {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState(0);

  const buttons = [
    { label: t("admin.payroll.employees.assign"), viewIndex: 0 },
    { label: t("admin.payroll.employees.bulkOnboard"), viewIndex: 1 },
    { label: t("admin.payroll.employees.history"), viewIndex: 2 },
  ];

  return (
    <Box>
      <Stack pb={2}>
        <Grid container spacing={1} sx={{ justifyContent: { xs: "center", md: "flex-start" } }}>
          {buttons.map(({ label, viewIndex }) => (
            <Grid item xs={12} sm={4} md="auto" key={viewIndex}>
              <Button
                sx={{
                  ...buttonStyles(activeSubTab === viewIndex),
                  width: { xs: "100%", md: "auto" },
                }}
                variant={activeSubTab === viewIndex ? "contained" : "outlined"}
                onClick={() => setActiveSubTab(viewIndex)}
                color="primary"
              >
                {label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Stack>

      <Box>
        {activeSubTab === 0 && <AssignCompensationView canEdit={canEdit} />}
        {activeSubTab === 1 && <BulkOnboardView canEdit={canEdit} />}
        {activeSubTab === 2 && <CompensationHistoryView canEdit={canEdit} />}
      </Box>
    </Box>
  );
};

EmployeesView.propTypes = {
  canEdit: PropTypes.bool.isRequired,
};

export default EmployeesView;
